const index = () => import('./Index');

//2022年省级专精特新“小巨人”企业培育奖补
export default {
  routes: [
    {
      path: '/smes/train/v2022/index',
      name: 'smes_train_2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/train/v2022/router.js